
import Vue from "vue"
import ArticleItem from "../blog/articleItem.vue";
export default Vue.extend({
	components: {
		ArticleItem
	},
	props: ["content", 'handleClickTitle']
})
